import { gsap } from "gsap"

function moveTopAnimation() {
  const button = document.querySelector('.move-top')
  const splashInner = document.querySelector('.move-top__splash-inner')
  const splashWrap = document.querySelector('.move-top__splash-wrap')
  const screenHeight = window.innerHeight
  let splashHeight = splashInner.offsetHeight
  
  let scrollHeight

  if (window.innerWidth > 768) {
    scrollHeight = screenHeight - (88 / 12.8)
  } else {
    scrollHeight = screenHeight - (80 / 3.9)
  }

  const waitTime = (Math.ceil(scrollHeight / (splashHeight / 30))) * 3 / 100

  // 画面の高さを超えるまで要素を繰り返す
  function repeatSplash() {
    while (splashHeight < screenHeight) {
      const clone = splashWrap.cloneNode(true)
      splashWrap.parentNode.insertBefore(clone, splashWrap.nextSibling) // 次の要素として挿入
      splashHeight += splashWrap.offsetHeight
    }
  }

  button.addEventListener('click', function() {
    repeatSplash() // 必要に応じて要素を繰り返す

    // 全てのスプラッシュ要素にアニメーションを適用
    const allSplashesWrap = document.querySelectorAll('.move-top__splash-wrap')

    requestAnimationFrame(() => {
      allSplashesWrap.forEach((element, index) => {
        const fadeIn = element.querySelector('.move-top__splash.-fade-in')

        gsap.to(fadeIn, {
          duration: 0.9,
          backgroundPosition: '100% 0',
          ease: 'steps(43)',
          delay: index * 0.9,
          onComplete: function() {
            element.querySelector('.move-top__splash.-fade-in').classList.add('-disabled')
            element.querySelector('.move-top__splash.-fade-out').classList.remove('-disabled')
            element.querySelector('.move-top__splash.-fade-in').style.backgroundPosition = '0 0'
          }
        })
      })

      gsap.delayedCall(waitTime, () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })

        function checkScrollComplete() {
          if (Math.abs(window.pageYOffset) < 1) {
            window.removeEventListener('scroll', checkScrollComplete)
            allSplashesWrap.forEach((element, idx) => {
              const fadeIn = element.querySelector('.move-top__splash.-fade-in')
              const fadeOut = element.querySelector('.move-top__splash.-fade-out')
              gsap.to(fadeOut, {
                duration: 0.9,
                backgroundPosition: '100% 0',
                ease: 'steps(43)',
                delay: idx * 0.9, // 順番にアニメーションを適用
                onComplete: function() {
                  fadeIn.classList.remove('-disabled')
                  fadeOut.classList.add('-disabled')
                  fadeOut.style.backgroundPosition = '0 0'
                }
              })
            })
          }
        }

        window.addEventListener('scroll', checkScrollComplete)
      })
    })
  })

  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 100) {
      button.classList.add('-is-active')
    } else {
      button.classList.remove('-is-active')
    }
  })
}

export default moveTopAnimation
